import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { VelocityTransitionGroup } from 'velocity-react';
import { TranslatedCopy } from '../../intl';
import { FUNDAMENTAL_RULE_TYPE } from '../../fundamentals/types';
import BasicSelect from '~COMPONENTS/formInputs/BasicSelect';
import FundamentalPreview from '~COMPONENTS/fundamentals/FundamentalPreview';
import { H2 } from '../../components';

class PdpFundamentalPicker extends Component {
  selectGraphicOption(name) {
    const {
      fundamentalRules,
      fundamentalSelection: { graphicOption },
      onSelect
    } = this.props;

    if (name !== graphicOption) {
      const upcomingTextOptions = fundamentalRules.filter(data => data.graphicType === name);

      onSelect(name, upcomingTextOptions.length === 1 ? upcomingTextOptions[0].graphicOption : null);
    }
  }

  selectTextOption(name) {
    const {
      fundamentalSelection: { graphicOption, textOption },
      onSelect
    } = this.props;

    if (name !== textOption) {
      onSelect(graphicOption, name);
    }
  }

  graphicOptions() {
    const { fundamentalRules } = this.props;

    return [...new Set(fundamentalRules.map(data => data.graphicType))].map(type => ({ label: type, value: type }));
  }

  textOptions() {
    const { fundamentalRules, fundamentalSelection } = this.props;
    return fundamentalRules
      .filter(data => data.graphicType === fundamentalSelection.graphicOption)
      .map(type => ({ label: type.graphicOption, value: type.graphicOption }));
  }

  selectedTextOption() {
    const {
      fundamentalRules,
      fundamentalSelection: { graphicOption, textOption }
    } = this.props;
    return fundamentalRules.find(data => data.graphicType === graphicOption && data.graphicOption === textOption);
  }

  render() {
    const { fundamentalSelection } = this.props;
    const textOptions = this.textOptions();
    const selectedTextOption = this.selectedTextOption();

    return (
      <div className='pdp_fp__wrapper'>
        <BasicSelect
          name='graphicOption'
          placeholder={new TranslatedCopy({ id: 'pdp.fundamental.graphicOption.placeholder' }).toString()}
          options={this.graphicOptions()}
          onChange={({ value }) => this.selectGraphicOption(value)}
          value={fundamentalSelection.graphicOption}
          className='mb7-sm'
        />
        <VelocityTransitionGroup enter={{ animation: 'slideDown' }} leave={{ animation: 'slideUp' }}>
          {textOptions.length > 1 && (
            <div className='mb7-sm'>
              <H2>
                <TranslatedCopy id='pdp.fundamental.textOption.title' />
              </H2>
              <BasicSelect
                name='textOption'
                placeholder={new TranslatedCopy({ id: 'pdp.fundamental.textOption.placeholder' }).toString()}
                options={textOptions}
                onChange={({ value }) => this.selectTextOption(value)}
                value={fundamentalSelection.textOption}
              />
            </div>
          )}
          {fundamentalSelection.textOption && (
            <div>
              <H2 className='mb7-sm'>
                <TranslatedCopy id='pdp.fundamental.textOption.preview' />
              </H2>
              <VelocityTransitionGroup enter={{ animation: 'fadeIn' }} leave={{ animation: 'fadeOut' }}>
                {selectedTextOption.organizationalGraphicUrl && (
                  <FundamentalPreview imageUrl={selectedTextOption.organizationalGraphicUrl} />
                )}
              </VelocityTransitionGroup>
            </div>
          )}
        </VelocityTransitionGroup>
      </div>
    );
  }
}

PdpFundamentalPicker.propTypes = {
  fundamentalRules: PropTypes.arrayOf(FUNDAMENTAL_RULE_TYPE).isRequired,
  fundamentalSelection: PropTypes.shape({
    graphicOption: PropTypes.string,
    textOption: PropTypes.string
  }).isRequired,
  onSelect: PropTypes.func.isRequired
};

export default PdpFundamentalPicker;
